export default __webpack_public_path__ + "static/media/monzoImg.b6af752c.png";